import React from "react";
import Header from "../components/Header/Header";
import Container from "@mui/material/Container";
import { Outlet } from "react-router";
import { useIsAuthenticated } from "@azure/msal-react";
import Auth from "../components/Auth/Auth";
import { DataProvider } from "../lib/context/DataContext";

export default function App() {
	const isAuth = useIsAuthenticated();

	if (isAuth)
		return (
			<DataProvider>
				<Header />

				<Container
					component="main"
					sx={{ p: 2 }}
					maxWidth="xl"
				>
					<Outlet />
				</Container>
			</DataProvider>
		);
	else return <Auth />;
}
